<template>
  <div class="home">
    <home-navbar></home-navbar>
    <div class="content">
      <img
        class="background"
        src="../../assets/web/membercenter.jpg"
      >
      <p
        class="handle_button"
        @click="showDialog"
      >马上开通</p>
    </div>
    <pay-dialog :dialog-visible='dialogVisible' ref="pay"></pay-dialog>

  </div>
</template>
<script>
import HomeNavbar from '@/partial/navbar'
import payDialog from './payDialog'
export default {
  components: {
    HomeNavbar, payDialog
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
      this.$refs.pay.getqrcode()
    },
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped>
.section {
  position: relative;
  width: 100%;
  height: 100%;
}
img {
  display: block;
  width: 100%;
}
.handle_button {
  width: 30%;
  height: 60px;
  background-color: #f85c5a;
  color: #ffffff;
  font-size: 25px;
  line-height: 60px;
  border-radius: 10px;
  /* margin: auto; */
  position: absolute;
  top: 82%;
  right: 35%;
  cursor: pointer;
}
</style>
